//#region src/internal/tool-helpers/breadcrumbs.ts
/**
* Fetches breadcrumbs from an issue event and formats them.
* Defaults to the latest event when eventId is omitted.
*/
async function fetchAndFormatBreadcrumbs(apiService, organizationSlug, issueId, eventId = "latest") {
	const event = await apiService.getEventForIssue({
		organizationSlug,
		issueId,
		eventId
	});
	const breadcrumbEntry = event.entries.find((e) => e.type === "breadcrumbs");
	const entryData = breadcrumbEntry?.data;
	const breadcrumbs = entryData?.values ?? [];
	return formatBreadcrumbs(breadcrumbs, issueId, event.id);
}
function formatBreadcrumbs(breadcrumbs, issueId, eventId) {
	if (breadcrumbs.length === 0) return [
		`# Breadcrumbs for ${issueId}`,
		"",
		`**Event ID**: ${eventId}`,
		"",
		"No breadcrumbs found in this event for the issue."
	].join("\n");
	const output = [
		`# Breadcrumbs for ${issueId}`,
		"",
		`**Event ID**: ${eventId}`,
		`**Total Breadcrumbs**: ${breadcrumbs.length}`,
		"",
		"```"
	];
	for (const crumb of breadcrumbs) {
		const timestamp = crumb.timestamp ? new Date(crumb.timestamp).toISOString() : " ".repeat(24);
		const level = (crumb.level ?? "info").padEnd(7);
		const category = crumb.category ?? crumb.type ?? "-";
		const message = cleanAndTruncate(crumb.message ?? "", 120);
		const data = formatBreadcrumbData(crumb.data);
		const parts = [`${timestamp} ${level} [${category}]`];
		if (message) parts.push(message);
		if (data) parts.push(data);
		output.push(parts.join(" "));
	}
	output.push("```");
	output.push("", "Breadcrumbs show the trail of events leading up to the error, in chronological order.", `Use \`get_sentry_resource(resourceType='issue', organizationSlug='...', resourceId='${issueId}')\` for full issue details.`);
	return output.join("\n");
}
/**
* Formats breadcrumb data as a compact inline JSON string.
*/
function formatBreadcrumbData(data) {
	if (!data || Object.keys(data).length === 0) return "";
	return cleanAndTruncate(JSON.stringify(data), 200);
}
/**
* Strips newlines and truncates a string to maxLen characters.
*/
function cleanAndTruncate(str, maxLen) {
	const clean = str.replace(/[\r\n]+/g, " ");
	if (clean.length <= maxLen) return clean;
	return `${clean.slice(0, maxLen)}...`;
}

//#endregion
export { cleanAndTruncate, fetchAndFormatBreadcrumbs, formatBreadcrumbData, formatBreadcrumbs };
//# sourceMappingURL=breadcrumbs-BltIlpas.js.map